<template>
    <div class="pp-popup-picker__wrap">
        <pInput ref="input" :value="currentLabel"
            :size="currentSize"
            :placeholder="$attrs.placeholder || '请选择'"
            v-bind="$attrs"
            readonly
            :disabled="currentDisabled"
            @focus="inputFocus">
        </pInput>
        <Popup ref="popup" class="pp-popup-picker"
            :visible.sync="showPopup" 
            animate="bottom" :height="height" :show-close="false">
            <header slot="title" class="pp-popup-picker__header">
                <span class="pp-popup-picker__header-cancel"
                    @click="close">
                    取消
                </span>
                <span>请选择</span>
                <span class="pp-popup-picker__header-submit"
                    @click="sure">
                    确定
                </span>
            </header>
            <ul>
                <slot></slot>
            </ul>
        </Popup>
    </div>
</template>

<script>
import Popup from '../../popup'
import pInput from '../../input'
import EventBus from '../../../src/util/event-bus.js'

/**
 * 弹窗选项
 * @param {string, number, Array} value v-model绑定值
 * @param {string} size 尺寸
 * @param {boolean} multiple 多选 default:false（后期）
 * @param {boolean} disabled 禁用
 * 
 * @event focus return {event, value}
 * @event change return value
 */
export default {
    name: 'pp-popup-picker',
    inheritAttrs: false,
    components: {
        Popup, pInput,
    },
    provide: function() {
        return {
            Picker: this,
        };
    },
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: [String, Number, Array],
        size: {
            type: String,
            default: 'normal',
            validator: function(value) {
                return ['normal', 'small', 'mini'].includes(value);
            },
        },
        multiple: Boolean,
        disabled: Boolean,
    },
    data: function() {
        return {
            currentValue: '',
            childrenValue: [],
            popup: null,
            showPopup: false,
        };
    },
    computed: {
        currentSize: function() {
            return this.Form.size || this.FormItem.size || this.size;
        },
        currentLabel: function() {
            let target = this.childrenValue.find(v=> v.value === this.value);
            return target ? target.label : this.value;
        },
        height: function() {
            return '50%';
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    watch: {
        showPopup: function(n) {
            if(!n) {
                this.inputBlur()
            }
        },
        value: function(n) {
            this.currentValue = n
        },
    },
    mounted: function() {
        this.currentValue = this.value
        this.createPopupToRoot()
    },
    methods: {
        inputFocus: function(e) {
            this.$emit('focus', {
                event: e,
                value: this.currentValue
            })
            this.showPopup = true
        },

        inputBlur: function(e) {
            this.$emit('blur', this.currentValue)

            EventBus.formItemTrigger.apply(this, ['blur', this.currentValue])
        },

        inputChange: function() {
            this.$emit('change', this.currentValue)

            EventBus.formItemTrigger.apply(this, ['change', this.currentValue])
        },

        focus: function() {
            this.$refs['input'].focus()
        },

        blur: function() {
            this.$refs['input'].blur()
            this.showPopup = false
        },

        update: function(label, value, key = '') {
            //HACK 只考虑multiple = false && typeof value !== 'object'的情况
            this.currentValue = value
        },

        sure: function() {
            this.$emit('input', this.currentValue)
            this.inputChange()
            this.close()
        },

        close: function() {
            this.showPopup = false
        },

        createPopupToRoot: function() {
            this.popup = this.$refs['popup']
            document.body.appendChild(this.popup.$el)
        },
    },
}
</script>
